exports.install = function (Vue) {
	
	/**
	 * 获取标准日期格式
	 * date 时间对象 例：new Date()
	 * strType 字符串类型，控制输出时间格式:yyyy-MM-dd hh:mm:ss
	 * 	注：yyyy为年份；MM为月份；dd为日；hh为小时；mm为分钟；ss为秒
	 * 
	 */
	Vue.prototype.getTimeStr = function (date,strType){
		let year=date.getFullYear();
		let month=date.getMonth()+1;
		month=month>9?month:'0'+month;
		let day=date.getDate();
		day=day>9?day:'0'+day;
		var hour = date.getHours();//得到小时
		hour=hour>9?hour:'0'+hour;
		var minu = date.getMinutes();//得到分钟
		minu=minu>9?minu:'0'+minu;
		var sec = date.getSeconds();//得到秒
		sec=sec>9?sec:'0'+sec;
		strType=strType.replace(/yyyy/g,year);
		strType=strType.replace(/MM/g,month);
		strType=strType.replace(/dd/g,day);
		strType=strType.replace(/hh/g,hour);
		strType=strType.replace(/mm/g,minu);
		strType=strType.replace(/ss/g,sec);
		return strType
	};
	
	/**
	 * 获取几天前的日期对象
	 * date 为计算的日期对象	 例：new Date()
	 * num 天数 	正数为传入日期日期之后，负数为传入日期之前
	 * 	注：返回为时间对象，获取日期字符串传入getTimeStr方法中获取
	 * 
	 */
	Vue.prototype.getTimeDate = function (date,num){//全局函数2
		var gettimes = date.getTime() + 1000 * 60 * 60 * 24 * num;
		date.setTime(gettimes); 
		return date;
	};

	/**
	 * 深拷贝对象数组
	 * obj 为对象或数组
	**/
	Vue.prototype.deepCopy = function(obj){
		let type = Object.prototype.toString.call(obj)
		if(type == "[object Array]"){
			let backObj = [];
			for(let val of obj){
				backObj.push(this.deepCopy(val))
			};
			return backObj;
		}
		if(type == "[object Object]"){
			let backObj = {};
			for(let key in obj){
				if(obj.hasOwnProperty(key)){
					backObj[key] = this.deepCopy(obj[key])
				}
			};
			return backObj;
		}
		return obj;
	};
	/**
	 * 获取字符串中特殊字符的个数
	 * scrstr 源字符串
	 * armstr 特殊字符
	**/
	Vue.prototype.getStrCount=function(scrstr,armstr){
		var count=0;
		while(scrstr.indexOf(armstr) >-1 )
		{
			scrstr = scrstr.replace(armstr,"")
			count++;   
		}
		return count;
	}
};
